import angular from 'angular'

angular.module('admin.genres.channels', []).controller('GenresChannelsCtrl', GenresChannelsCtrl)

/** @ngInject */
function GenresChannelsCtrl($stateParams, ChannelsService, GenresService) {
  var vm = this

  vm.items = []
  vm.perPage = 25
  vm.pathImgThumb = ''
  vm.id = $stateParams.id

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    GenresService.listChannelsByGenre(vm.id, vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }

        if (result.results[i].st === 0) {
          result.results[i].status = 'Draft'
        } else if (result.results[i].st === 1) {
          result.results[i].status = 'Published'
        } else if (result.results[i].st === 2) {
          result.results[i].status = 'Sold Out'
        } else if (result.results[i].st === 3) {
          result.results[i].status = 'Unavailable'
        } else if (result.results[i].st === 4) {
          result.results[i].status = 'Awaiting Collectible Count'
        } else if (result.results[i].st === 5) {
          result.results[i].status = 'Coming Soon'
        }
      }
      vm.items = result.results
    })
  }

  load(1)

  vm.load = function () {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function (newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  // vm.add = function (item) {
  //   $('#myModalAdd').modal('show')
  // }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelsService.update(item.id, { 'id-gen': null }).then(
            function () {
              $('#myModalAdd').modal('hide')
              load(1)
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }
}
